import React from "react";
import { VariantOption } from "types";
import { PromptModal } from "@/components/Common/PromptModal";

interface DeleteVariantOptionModalProps {
    isOpen: boolean;
    option: VariantOption | undefined;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteVariantOptionModal = ({ isOpen, option, onClose, onConfirm }: DeleteVariantOptionModalProps) => {
    if (!isOpen || !option) {
        return null;
    }

    return (
        <PromptModal
            isOpen={isOpen}
            title="Delete Item"
            color="danger"
            dialogText={{ secondary: "Cancel", submit: "Delete" }}
            onClose={onClose}
            onConfirm={onConfirm}
        >
            <div className="space-y-4 break-all text-center">
                <p>Are you sure you want to delete the &ldquo;{option.name}&rdquo; variant?</p>
                <p>
                    This action cannot be un-done. Reports will list this variant as &ldquo;deleted&rdquo; and its
                    existing inventory will be removed.
                </p>
            </div>
        </PromptModal>
    );
};
